import { Typography } from "antd";
import {
  LOYALTY_PACKAGE_STATUS,
  LOYALTY_STATUS_COLOR,
  LOYALTY_STATUS_LABEL,
} from "features/LoyaltyPackage/core/constants";

const { Text } = Typography;

function LoyaltyStatusBadge({ status }) {
  const color = LOYALTY_STATUS_COLOR[status] ?? "#5b6673";
  const label = LOYALTY_STATUS_LABEL[status] ?? status;
  const textColor = status === LOYALTY_PACKAGE_STATUS.COMPLETED ? "#000000" : color;

  return (
    <span className="loyalty-detail-status">
      <span className="loyalty-detail-status-dot" style={{ backgroundColor: color }} />
      <Text style={{ color: textColor }}>{label}</Text>
    </span>
  );
}

export default LoyaltyStatusBadge;
